import { combineReducers } from 'redux';
import viewItem from './view-item/reducer';
import { reducer as reportItem } from './report-item/reducer';
import profile from './profile/reducer';
import startPage from './start-page/reducer';
import checkout from './checkout/reducer';
import syi from '../../apps/syi/state/reducer';
import myTradera from './my-tradera/reducer';
import shippingCalculator from './shipping-calculator/reducer';
import cart from './cart/reducer';
import traderaShop from './tradera-shop/reducer';
import shippingCheckout from './shipping-checkout/reducer';
import invoiceCheckout from './invoice-checkout/reducer';
import { reducer as cause } from './cause/reducer';
import payouts from './payouts/reducer';
import initData from 'init-data';

const reducers = {
    cause,
    checkout,
    myTradera,
    profile,
    cart,
    reportItem,
    shippingCalculator,
    startPage,
    viewItem,
    traderaShop,
    shippingCheckout,
    invoiceCheckout,
    payouts
};
if (initData.pageName === 'SellItem') {
    reducers.syi = syi;
}

export default combineReducers(reducers);
